export default __webpack_public_path__ + "static/media/wasteless.421ad7b8.svg";